import React from 'react';
import { spokenLanguages } from '../data/resume';
import './SpokenLanguages.css';

const proficiencyLevel = (p) => {
  const map = {
    'Native': 5,
    'Professional': 4,
    'Limited Working': 3,
    'Elementary': 2,
    'Fundamental': 1,
  };
  return map[p] || 1;
};

export default function SpokenLanguages() {
  return (
    <section id="languages" className="section-wrap">
      <h2 className="section-title">Languages</h2>
      <div className="lang-grid">
        {spokenLanguages.map((lang) => {
          const level = proficiencyLevel(lang.proficiency);
          return (
            <div className="lang-card" key={lang.language}>
              <div className="lang-name">{lang.language}</div>
              <div className="lang-proficiency mono">{lang.proficiency}</div>
              <div className="lang-dots">
                {[1,2,3,4,5].map((i) => (
                  <span
                    key={i}
                    className={`lang-dot ${i <= level ? 'lang-dot--filled' : ''}`}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
